import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NicaFiltroComponent } from '../nica-filtro/nica-filtro.component';
import { ExcelExporterComponent } from '../excel-exporter/excel-exporter.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { Utenteservice } from '../../../services/utente.service';
import { Utente } from '../../../class/userinterface';
import { NicaAnagraficaComponent } from '../../nica-anagrafica/nica-anagrafica.component';

@Component({
  selector: 'app-pannello-gestione-strutture-excel',
  templateUrl: './pannello-gestione-strutture-excel.component.html',
  styleUrls: ['./pannello-gestione-strutture-excel.component.css', '../../../views/ana-soggetto/ana-soggetto.component.css']
})
export class PannelloGestioneStruttureExcelComponent implements OnInit {

  @Output('onPannelloGestioneStruttureEvent') onPannelloGestioneStruttureEvent: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('excelExporterAsService', { static: false }) excelExporterAsService: ExcelExporterComponent;

  @ViewChild('dataGridStrutture', { static: false }) dataGridStrutture: NicaAnagraficaComponent;

  @Input() idCategoriaModello?: string;
  @Input() advancedXlsExportAddWorksheet?: Array<Record<string, any>> = [];
  @Input() advancedXlsExportAddWorksheetName?: string = 'Informazioni aggiuntive';
  @Input() addFilterColumnToAdvancedXls: boolean = false;
  @Input() api?: string;
  @Input() customApiAdvancedXls: string | null = null;
  @Input() wingap?: boolean = true;
  @Input() nascondiCelleRipetuteColonneOrdinate?: boolean = true;
  @Input() filter?: string;


  itemData: any = {};


  bottoniExporter = [
    {
      location: "after",
      stylingMode: "text",
      widget: "dxButton",
      locateInMenu: "never",
      text: 'Esporta',
      icon: 'xlsxfile', //"export icon-esporta-xlsx",
      event: 'generaExcel',
      cssClass: 'escludiQuesto',
    },
    {
      location: "after",
      stylingMode: "text",
      widget:
        "dxButton",
      locateInMenu: "never",
      text: 'Salva',
      icon: "glyphicon mdi mdi-content-save-outline",
      event: 'salva',
      cssClass: 'salvaButtonExcelExporter',
      class: 'salvaButtonExcelExporter',
    },
    {
      location: "after",
      stylingMode: "text",
      widget: "dxButton",
      locateInMenu: "never",
      text: 'Annulla',
      icon: "glyphicon glyphicon icon-annulla-form",
      event: 'annullaExcel',
      cssClass: 'escludiQuesto'
    },
  ];

  pannelloExcelExporterVisibile: boolean = false;
  pannelloExcelExporterAsServiceVisibile: boolean = false;

  idUtenteConnesso?: number;

  modelloSelezionato?: any;

  constructor(private spinner: NgxSpinnerService, private utenteService: Utenteservice) { }

  ngOnInit(): void {

    this.idUtenteConnesso = parseInt(this.utenteService.InfoDatiUtenteConnesso.idAccount);

    if (document.getElementsByClassName('page-title')) {

      for (let i = 0; i < document.getElementsByClassName('page-title').length; i++) {

        if ((document.getElementsByClassName('page-title').item(i) as HTMLParagraphElement).innerHTML.toLowerCase().startsWith('duplicazione'))
          (document.getElementsByClassName('page-title').item(i) as HTMLParagraphElement).innerHTML = `Pannello Strutture Excel`;



      }

    }


    setTimeout(
      () => {

        if ($('#grigliaStrutture').find('.dx-freespace-row')) {

          let elements = $('#grigliaStrutture').find('.dx-freespace-row');

          //console.warn(elements);

          for (let i = 0; i < elements.length; i++) {


            elements[i].style.height = '450px';

          }


        }

        /*
        if(document.getElementsByClassName('dx-row dx-freespace-row dx-column-lines dx-state-hover')){

          for(let i = 0 ; i< document.getElementsByClassName('dx-row dx-freespace-row dx-column-lines dx-state-hover').length;i++){
          

            if(document.getElementsByClassName('dx-row dx-freespace-row dx-column-lines dx-state-hover').item(i).parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.id=='grigliaStrutture')
            {
              (document.getElementsByClassName('dx-row dx-freespace-row dx-column-lines dx-state-hover').item(i) as HTMLElement).style.height='500px';
            
              break;
            }
          }
    
    
        }
        */
        /*
        if($('.dx-freespace-row').parent('#grigliaStrutture')){

          let elements = $('.dx-freespace-row');

          for(let i = 0 ; i< elements.length;i++){
          
            if(elements[i] && $(elements[i]).parent('#grigliaStrutture'))
              elements[i].style.height='500px';
           
          }
    
    
        }*/

      }, 500
    )

  }


  onAperturaPopup(evt) {

    evt.component.content().parentNode.classList.add("bg-grey"); //add class to overlay content
    evt.component.content().parentNode.classList.add("formEditPopup"); //add class to overlay content
    //e.component.content().parentNode.classList.add("popup"); //add class to overlay content
    evt.component.content().classList.add("soggetto-form"); //add class to content

  }

  /*
  async onChiusuraAnnullaFiltro(evt){

    if (this.nicaFiltro)
      await this.nicaFiltro.annullaFiltro();


  }
  */

  onChiusuraPopup(evt) {

    if (evt)
      this.onPannelloGestioneStruttureEvent.emit('chiudi');

  }


  async onAllEventStrutture(evt) {

    //console.warn(evt);

    if (evt.name == 'onCellPrepared') {
      if (evt.rowType === "data" && evt.column.command === "edit" && evt.column.buttons[0]['name'] == 'edit' && evt.row.data.tipoStruttura == 2 && evt.row.data.idUtenteCreator !== this.idUtenteConnesso) {

        console.warn(evt);

        //evt.cellElement.style='visibility:hidden;';



        evt.cellElement.innerHTML = '<span class="dx-link dx-link-copy dx-icon-copy dx-link-icon" title="Duplica" aria-label="Duplica"></span>&nbsp;';


        (evt.cellElement as HTMLElement).onclick = () => {



          this.bottoniExporter[1].icon = 'copy';
          this.bottoniExporter[1].text = 'Duplica';


          this.itemData = evt.data;

          this.itemData['method'] = 'post';

          this.itemData['isDuplicating'] = true;

          setTimeout(
            () => {

              this.pannelloExcelExporterVisibile = true;

              //console.warn({html:document.getElementsByClassName('page-title'),titolo:evt.data.descrizione});


              if (document.getElementsByClassName('page-title')) {

                for (let i = 0; i < document.getElementsByClassName('page-title').length; i++) {


                  if ((document.getElementsByClassName('page-title').item(i) as HTMLParagraphElement).innerHTML.toLowerCase() == 'pannello strutture excel')
                    (document.getElementsByClassName('page-title').item(i) as HTMLParagraphElement).innerHTML = `Duplicazione Struttura: ${evt.data.descrizione}`;



                }



              }

            }, 500
          )


          return;
        }




      }


    }
    if (evt.name == "onSaved") {
      if (document.getElementsByClassName('page-title')) {

        for (let i = 0; i < document.getElementsByClassName('page-title').length; i++) {


          if ((document.getElementsByClassName('page-title').item(i) as HTMLParagraphElement).innerHTML.toLowerCase().startsWith('duplicazione'))
            (document.getElementsByClassName('page-title').item(i) as HTMLParagraphElement).innerHTML = `Pannello Strutture Excel`;



        }

      }
    }
    if (evt.name == "onSaving") {
      if (document.getElementsByClassName('page-title')) {

        for (let i = 0; i < document.getElementsByClassName('page-title').length; i++) {

          if ((document.getElementsByClassName('page-title').item(i) as HTMLParagraphElement).innerHTML.toLowerCase().startsWith('duplicazione'))
            (document.getElementsByClassName('page-title').item(i) as HTMLParagraphElement).innerHTML = `Pannello Strutture Excel`;



        }

      }
      //console.log("Nuova Azienda OnSaving", evt);
    }

    //Alla modifica di un modello presistente
    if (evt.name == "onEditorPreparing") {
      evt.cancel = true;





      /*
      setTimeout(
        ()=>{

          this.dataGridStrutture.griglia.columns[0]['buttons'][0].name = 'copy';

        },5000
      )*/

      //this.pannelloExcelExporterVisibile = true;

    }

    //All'aggiunta di un nuovo modello
    if (evt.name == "onInitNewRow") {

      evt.cancel = true;

      this.bottoniExporter[1].icon = 'glyphicon mdi mdi-content-save-outline';
      this.bottoniExporter[1].text = 'Salva';

      this.itemData['method'] = 'post';

      this.itemData['isDuplicating'] = false;

      this.pannelloExcelExporterVisibile = true;

    }
    if (evt.name == "onEditorPrepared") {

      evt.cancel = true;

      this.bottoniExporter[1].icon = 'glyphicon mdi mdi-content-save-outline';
      this.bottoniExporter[1].text = 'Salva';

      this.itemData = evt.data;

      this.itemData['method'] = 'put';


      this.pannelloExcelExporterVisibile = true;

    }

    /*
    setTimeout(() => {
      if (evt.formDataChanged.hasOwnProperty('tipoStruttura')) {
        if (evt.formDataChanged.tipoStruttura) {
          evt.component.itemOption('strutturaExcelGriglia.tipoStruttura', 'value', 'Pubblico');
        }
        else
          evt.component.itemOption('strutturaExcelGriglia.tipoStruttura', 'value', 'Privato');

      }
    }, 400);
    */
  }



  async onOptionalButtonClick(evt) {


    if (evt.name == 'scaricaExcel') {


      await this.spinner.show();

      this.pannelloExcelExporterAsServiceVisibile = true;

      setTimeout(
        async () => {

          this.excelExporterAsService.colonneDaOrdinare = (evt.row.data.listaOrdinamento as any[]).map(
            (ord) => { return ord.idFieldDTB }
          );
          this.excelExporterAsService.skip = true;

          this.excelExporterAsService.api = this.api;

          this.excelExporterAsService.filter = this.filter;

          this.excelExporterAsService.itemData.descrizione = evt.row.data['descrizione'];

          this.excelExporterAsService.variabiliScelte = evt.row.data.listaVariabili;





          await this.excelExporterAsService.gestisciEventoPulsante('generaExcel');


          this.excelExporterAsService.isFileAppenaScaricato.subscribe(
            async (res) => {

              if (res) {


                this.pannelloExcelExporterAsServiceVisibile = false;


                await this.spinner.hide();

              }
            }
          );

        }, 1000
      );






    }

    //this.onPannelloGestioneStruttureEvent.emit(undefined);

  }

  gestisciEventoExcelExporter(evt) {


    if (typeof evt == 'undefined') {


      this.pannelloExcelExporterVisibile = false;

      if (document.getElementsByClassName('page-title')) {

        for (let i = 0; i < document.getElementsByClassName('page-title').length; i++) {

          if ((document.getElementsByClassName('page-title').item(i) as HTMLParagraphElement).innerHTML.toLowerCase().startsWith('duplicazione'))
            (document.getElementsByClassName('page-title').item(i) as HTMLParagraphElement).innerHTML = `Pannello Strutture Excel`;



        }

      }

    }

  }


  async onFilterQueryStringEmitted(evt?: string) {

    console.warn(evt);

    this.api += evt;
    //this.pannelloExcelExporterVisibile=true;


    if (!evt)
      return;



  }
}


